import { AppRoutes, NavigationConfig } from "@/config/navigation-config";
import publicConfig from "@/config/public.config";
import { AuthError, AuthErrorMessages } from "@/lib/errors";
import { createClient } from "@/utils/supabase/client";
import { z } from "zod";

const forgotPasswordSchema = z.object({
  email: z.email(),
});

type ForgotPasswordResult =
  | { success: true }
  | { success: false; error: string };

export async function forgotPassword(
  formData: FormData,
): Promise<ForgotPasswordResult> {
  const supabase = await createClient();

  const email = formData.get("email");
  const validatedFields = forgotPasswordSchema.safeParse({
    email,
  });

  if (!validatedFields.success) {
    return {
      success: false,
      error: AuthErrorMessages[AuthError.INVALID_EMAIL],
    };
  }

  const { error } = await supabase.auth.resetPasswordForEmail(
    validatedFields.data.email,
    {
      redirectTo: `${publicConfig.baseUrl}/auth/callback?next=${
        encodeURIComponent(
          NavigationConfig.getPath(
            AppRoutes.RESET_PASSWORD,
          ),
        )
      }`,
    },
  );

  if (error) {
    return {
      success: false,
      error: AuthErrorMessages[AuthError.RESET_EMAIL_FAILED] ??
        error.message,
    };
  }

  return { success: true };
}
